import { font_dark_theme, font_theme } from 'framework/theme/constants/font';

import { PopoverTheme } from '../types';

export const popover_theme: Pick<PopoverTheme, 'general'> = {
  general: {
    font_family: font_theme.general.font_family,
    font_size: font_theme.general.font_size_normal,
    backdrop_filter: 'blur(4px)',
    border_radius: '4px',
    padding: '0px',
  },
};

export const popover_dark_theme: PopoverTheme = {
  general: popover_theme.general,
  background: { normal: 'rgba(17, 18, 20, 0.8)' },
  color: {
    normal: font_dark_theme.color.normal,
    hover: font_dark_theme.color.hover,
    active: font_dark_theme.color.active,
  },
  border: { normal: '1px solid #2b3036' },
};
